export default __webpack_public_path__ + "static/media/previousIcon.94321f53.svg";